import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "d-flex justify-content-end" }
const _hoisted_3 = { class: "p-3 fw-bold" }
const _hoisted_4 = {
  class: "row mx-1 dashbord-list",
  style: {"height":"95%"}
}
const _hoisted_5 = { class: "summary" }
const _hoisted_6 = { class: "remaining" }
const _hoisted_7 = { class: "prediction" }
const _hoisted_8 = { class: "d-flex justify-content-end m-3" }

import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OverTimeDetailModal',
  props: {
    modelValue: { type: Boolean },
    start_date: {},
    end_date: {},
    details: {},
    threshold_seconds: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const month = computed(() => {
  return new Date(props.end_date).getMonth() + 1
})

const convertSecondsToHHmm = computed(() => (seconds: number) => {
  let hour = Math.floor(seconds / 3600);
  let minutes: string | number = Math.floor(seconds % 3600 / 60);
  if (minutes < 10) minutes = '0' + minutes;

  return (hour + ':' + minutes);
})

function getClass(summary, prediction_monthly_summary, threshold) {
  let ret = ""
  if (threshold == 0) return ret
  if (summary >= threshold) ret += "overThresholdSummary "
  if (prediction_monthly_summary >= threshold) ret += "overThresholdPrediction "
  return ret
}

function getRemainingTime(summary, threshold) {
  const remaining = threshold - summary
  if (remaining < 0) return 0
  return remaining
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(InfoModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    title: _unref(i18n).global.t('pages.dashboard.overTime.title'),
    modalHeight: "80%",
    slotTextAreaHeight: "60%"
  }, {
    text: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("small", _hoisted_3, _toDisplayString(`${month.value} ${_unref(i18n).global.t('pages.dashboard.monthly')} (${props.start_date} ~ ${props.end_date}) ${_unref(i18n).global.t('pages.dashboard.displayData')}`), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, { class: "h-100 px-0" }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.driverName')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.overTime.monthlySummary')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.overTime.remainingTime')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.dashboard.overTime.predictionMonthlySummary')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (props.details?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.details, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.driver_id,
                        class: _normalizeClass(getClass(
                    item.monthly_summary,
                    item.prediction_monthly_summary,
                    props.threshold_seconds
                  ))
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.last_name) + " " + _toDisplayString(item.first_name), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(convertSecondsToHHmm.value(item.monthly_summary)), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(convertSecondsToHHmm.value(getRemainingTime(item.monthly_summary, props.threshold_seconds))), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(convertSecondsToHHmm.value(item.prediction_monthly_summary)), 1)
                      ], 2))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_btn, {
          class: "m-1 reset-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.closeBtn')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})